import { render, staticRenderFns } from "./consultQuestion.vue?vue&type=template&id=46744773&scoped=true&"
import script from "./consultQuestion.vue?vue&type=script&lang=js&"
export * from "./consultQuestion.vue?vue&type=script&lang=js&"
import style0 from "./consultQuestion.vue?vue&type=style&index=0&id=46744773&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46744773",
  null
  
)

export default component.exports